import React from 'react'

import { usePlaces } from '../_load/PlacesLoader'
import PlacesListItem from './PlacesListItem'

const PlacesList = () => {
  const places = usePlaces()

  return places.map(item => <PlacesListItem key={item.id} item={item} />)
}

export default PlacesList
